import React from 'react';
import { createRoot } from 'react-dom/client';
import Popup from '../components/Popup';

export default function showPopup(message, title = '', opts = {}) {
  return new Promise((resolve) => {
    try {
      const container = document.createElement('div');
      document.body.appendChild(container);
      const root = createRoot(container);

      const close = (ret) => {
        try {
          root.unmount();
          if (container.parentNode) container.parentNode.removeChild(container);
        } catch (e) {}
        resolve(ret);
      };

      // If a confirm dialog is requested, render a simple confirm UI
      if (opts.confirm) {
        const Confirm = ({ title, message }) => (
          React.createElement('div', { className: 'popup-backdrop', role: 'dialog', 'aria-modal': true },
            React.createElement('div', { className: `popup-card popup-${opts.type || 'info'}` },
              title ? React.createElement('h3', { className: 'popup-title' }, title) : null,
              React.createElement('div', { className: 'popup-body' }, message),
              React.createElement('div', { className: 'popup-actions' },
                React.createElement('button', { className: 'popup-btn', onClick: () => close(false) }, 'Cancel'),
                React.createElement('button', { className: 'popup-btn', onClick: () => close(true) }, 'OK')
              )
            )
          )
        );

        root.render(React.createElement(Confirm, { title, message }));
      } else {
        root.render(
          React.createElement(Popup, {
            title: title,
            message: message,
            onClose: () => close(true),
            type: opts.type || 'info'
          })
        );
      }
    } catch (err) {
      // Fallback to native alert if something goes wrong
      try { window.alert(message); } catch (e) {}
      resolve(true);
    }
  });
}
